Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.ThematicsAndComplaintsSectionView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']

  initialize: (@subsections, @model) ->

    # just set @options

  render: ->
    @$el.html(@template({}))
    for subsection in @subsections
      @$('.container').append(subsection.render().el)
    @model.fetchData()
    return this